module.exports = __webpack_public_path__ + "img/030.60fbd83b.png";